<template>
  <div class="TransactionsTab">
    <empty-info />
  </div>
</template>

<script>
import EmptyInfo from "../../tabs/partials/EmptyInfo";
export default {
  name: "TransactionsTab",
  components: {EmptyInfo}
}
</script>

<style scoped>

</style>
